import { render, staticRenderFns } from "./ExtractionFieldGroup.vue?vue&type=template&id=68eac16d&scoped=true&"
import script from "./ExtractionFieldGroup.vue?vue&type=script&lang=js&"
export * from "./ExtractionFieldGroup.vue?vue&type=script&lang=js&"
import style0 from "./ExtractionFieldGroup.vue?vue&type=style&index=0&id=68eac16d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68eac16d",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VExpansionPanels } from 'vuetify/lib/components/VExpansionPanel';
installComponents(component, {VDivider,VExpansionPanels})
